export enum NotificationProvider {
  SNS = 'Sns',
  ONESIGNAL = 'OneSignal',
}

export default interface ConfigurationsDto {
  activationAdaptivePlacementTestLearnosityEnabled: boolean;
  activationPlacementTestEnabled: boolean;
  activationPlacementTestLearnosityEnabled: boolean;
  gamificationDesktopUIEnabled: boolean;
  gamificationEnabled: boolean;
  gamificationMobileUIEnabled: boolean;
  lfaActivationMobileUIEnabled: boolean;
  liveClassJoinPollTime: 30000;
  liveClassStudentSignUpEnd: 3;
  liveClassStudentSignUpStart: 10;
  liveClassOnboardingEnabled: boolean;
  miniLessonBetaUserEnabled: boolean;
  newLiveClassLogic: boolean;
  notificationsPollTime: 300000;
  pcRevampDesktopUIEnabled: boolean;
  pcUpsellEnabled: boolean;
  speechaceCarouselEnabled: boolean;
  speechaceCarouselMobileEnabled: boolean;
  coachMobileUIEnabled: boolean;
  isExtoleEnabled: boolean;
  isPlatformTourGCEnabled: boolean;
  liveClassPromoTileEnabled: boolean;
  copilotAutoplayEnabled: boolean;
  copilotAudioStreamEnabled: boolean;
  notificationMobilePushProvider: NotificationProvider;
  notificationWebPushProvider: NotificationProvider;
  oneSignalAppId: string;
  yearInReviewEnabled: boolean;
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/ConfigurationsDto.ts